<template>
  <v-dialog
    v-model="setDialog"
    max-width="500"
    scrollable
  >
    <v-card data-cy="modal_excluir">
      <v-card-title
        class="title pt-5 pb-0"
        primary-title
        data-cy="modal_titulo"
      >
        <slot name="titulo" />
      </v-card-title>

      <v-card-text
        class="pt-3 pb-8"
        data-cy="modal_texto"
      >
        <p class="mb-0 body-1">
          <slot name="texto" />
        </p>
      </v-card-text>

      <v-card-actions class="pt-0">
        <v-spacer />
        <v-btn
          v-if="doisBotoes"
          color="primary"
          text
          class="px-8"
          data-cy="modal_btn_cancelar"
          @click="setDialog = false"
        >
          <slot name="btFalse" />
        </v-btn>

        <v-btn
          color="primary"
          text
          class="px-8"
          data-cy="modal_btn_confirmar"
          @click="setDialog = true"
        >
          <slot name="btTrue" />
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalConfirmacao',

  props: {
    showDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    doisBotoes: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    setDialog: {
      get() {
        return this.showDialog;
      },
      set(value) {
        if (!value) this.$emit('changeDialog', value);

        this.$emit('changeDialog', value);
      },
    },
  },
};
</script>
